import React from "react"
import { useFormikContext } from "formik"
import { useOrder } from "context/order"
import { useLocale } from "context/locale"
import Button from "components/Button"
import Checkbox from "components/Checkbox"

import StyledStepFifth from "./styles"

const StepFifth = () => {
  const { t, lang } = useLocale()
  const { isValid } = useFormikContext()
  const { step, setStep, res_error } = useOrder()

  return (
    <div className="form-step" style={step !== 5 ? { display: "none" } : {}}>
      <StyledStepFifth>
        <h4 className="order-courier-form__subheader">{t("Your donation")}</h4>
        <div className="last-step-wrapper">
          <div className="last-step-checks">
            <Checkbox name="privacy_policy">
              {lang === "pl"
                ? "Zapoznałem się z <a href='https://ubraniadooddania.pl/static_pages/regulaminy-oraz-polityka-prywatnosci' target='_blank'>polityką prywatności</a> oraz <a href='/regulamin-serwisu/' target='_blank'>regulaminem</a> i akceptuję je. Równocześnie wyrażam zgodę na utworzenie konta w serwisie. *"
                : "I have read and agree to the <a href='/en/service-terms/'>Privacy Policy</a>. At the same time, I agree to create an account on the website. *"}
            </Checkbox>
            <Checkbox
              name="anonymous"
              label={t("I want to donate anonymously. *")}
            />
            <Checkbox
              name="data_transfer"
              label={t(
                "I agree to receive commercial correspondence with offers and promotions from New Solutions Group sp. z o.o. I acknowledge that I have the right to withdraw the above consents. The withdrawal of the consents will not affect the lawfulness of the data processing that was carried out prior to this cancellation."
              )}
            />
            <span>*{t("Pole wymagane")}</span>
          </div>
        </div>
        {res_error && (
          <div className="error-block">
            <p>{res_error}</p>
          </div>
        )}
        <div className="order-courier-form__cta">
          <Button
            type="button"
            text={t("Back")}
            variant="prev"
            onClick={() => setStep(4)}
          />
          <Button
            type="submit"
            text={t("Next")}
            variant="next"
            disabled={!isValid}
          />
        </div>
      </StyledStepFifth>
    </div>
  )
}
export default StepFifth
